
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../_helpers/apiConfig';
import { toast } from 'react-toastify';


export const learnerManagement = createAsyncThunk("/adminApi/lernerList", async (filters) => {
  const response = await apiRequest('POST', '/v1/adminApi/lernerList', filters);
  return response;
});

export const expertManagement = createAsyncThunk("/adminApi/expertList", async (filters) => {
  const response = await apiRequest('POST', '/v1/adminApi/expertList', filters);
  return response;
});

export const userPageCounts = createAsyncThunk("/adminApi/userPageCounts", async (filters) => {
  const response = await apiRequest('POST', '/v1/adminApi/userPageCounts', filters);
  return response;
});
export const verifyFlutterwaveTransaction = createAsyncThunk("order/flutterwave/verification", async (filters) => {
  const response = await apiRequest('POST', '/v1/order/flutterwave/verification', filters);
  return response;
});





export const getExpertProfile = createAsyncThunk("/user/getExpertProfile", async (filters) => {
  const response = await apiRequest('POST', '/v1/user/getExpertProfile', filters);
  return response;
});





export const updateUserStatus = createAsyncThunk("/adminApi/updateUserStatus",
  async (arg, thunkAPI) => {
    const { Payload, forReferesh, apiRequestData2 } = arg;
    const response = await apiRequest("POST", "v1/adminApi/updateUserStatus", Payload);
    if (response.message) {
      thunkAPI.dispatch(learnerManagement(forReferesh));
      thunkAPI.dispatch(expertManagement(apiRequestData2));


    }
    return response;
  }
);


export const updateExpertUserStatus = createAsyncThunk(
  "/adminApi/updateUserStatus",
  async ({ Payload, forReferesh, apiRequestData2 }, thunkAPI) => {
    const { dispatch } = thunkAPI;
    try {
      console.log('Updating User Status:', Payload);

      const response = await apiRequest("POST", "v1/adminApi/updateUserStatus", Payload);
      console.log("5454545", response)

      if (response.message) {
        dispatch(expertManagement(apiRequestData2));
        dispatch(learnerManagement(forReferesh));
      }

      return response;
    } catch (error) {
      console.error("Error updating user status:", error);
      return thunkAPI.rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const updateuser = createAsyncThunk("/adminApi/updateUser",
  async (arg, thunkAPI) => {
    const { Payload, forReferesh, apiRequestData2, } = arg;
    const response = await apiRequest("POST", "v1/adminApi/updateUser", Payload);

    if (response.message) {
      thunkAPI.dispatch(learnerManagement(forReferesh))
      thunkAPI.dispatch(expertManagement(apiRequestData2));
      toast.success("Updated successfully")
    }


    return response;
  }
);





const expertSlice = createSlice({
  name: 'experts',
  initialState: {
    experts: [],
    learners: [],
    total: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(learnerManagement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(learnerManagement.fulfilled, (state, action) => {
        state.loading = false;
        state.learners = action?.payload?.data?.list;
        state.totalLearner = action?.payload?.data?.total;

      })
      .addCase(learnerManagement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateUserStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.learners = action?.payload;

      })
      .addCase(updateUserStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })


      .addCase(updateuser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateuser.fulfilled, (state, action) => {
        state.loading = false;
        state.learnersUpdate = action?.payload;

      })
      .addCase(updateuser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })



      .addCase(expertManagement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(expertManagement.fulfilled, (state, action) => {
        state.loading = false;
        state.experts = action?.payload?.data?.list;
        state.totalExpert = action?.payload?.data?.total;
      })
      .addCase(expertManagement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })


      .addCase(getExpertProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExpertProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.getExpertProfile = action?.payload?.data;
      })
      .addCase(getExpertProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })



      .addCase(userPageCounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userPageCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.userCounts = action?.payload?.data;
      })
      .addCase(userPageCounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default expertSlice.reducer;
